import React from 'react';
import {
  Typography,
} from '@one-thd/sui-atomic-components';

import {
  string, number, oneOfType
} from 'prop-types';

export const CabinetInfoSection = ({
  height,
  width,
  depth,
  unit
}) => {

  function measurementWithLabel(measurement) {
    return measurement ? `${measurement} ${unit}` : '';
  }

  return (
    <div
      className="section cabinet-info-section"
    >
      <div className="sui-flex sui-gap-x-6 sui-flex-wrap sui-py-4 sui-w-full">
        <div className="sui-flex sui-gap-x-2 sui-pr-2">
          <Typography variant="body-base" color="primary" weight="bold">
            Total Cabinet Dimensions:
          </Typography>
        </div>
        <div className="sui-flex sui-gap-x-8 sui-pr-2">
          <Typography variant="body-base" color="primary">
            Height: <b>{measurementWithLabel(height)}</b>
          </Typography>
          <Typography variant="body-base" color="primary">
            Width: <b>{measurementWithLabel(width)}</b>
          </Typography>
          <Typography variant="body-base" color="primary">
            Depth: <b>{measurementWithLabel(depth)}</b>
          </Typography>
        </div>
      </div>
    </div>
  );
};

CabinetInfoSection.propTypes = {
  height: oneOfType([string, number]),
  width: oneOfType([string, number]),
  depth: oneOfType([string, number]),
  unit: string
};

CabinetInfoSection.defaultProps = {
  height: '',
  width: '',
  depth: '',
  unit: 'in'
};